import { render, staticRenderFns } from "./KCVCardList.vue?vue&type=template&id=768d7216&"
import script from "./KCVCardList.vue?vue&type=script&lang=js&"
export * from "./KCVCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports